// removed by extract-text-webpack-plugin
module.exports = {"thankyou_container":"_318-6Cw01_sRT8U0xSWoTN","client_logo":"_2s9UzNh3B-Xo29dL1FMMBI","testimonial_redirection":"_3ZZeSWiF2JfdxGHxXG8Ddj","timer":"excpp_d1DRE42jFzFjm8k","label-pulsate":"FLMoGWyEuZc8om_XXtus7","thankyou_img":"_2-21LY1vVGZFyT0YaFjg8s","thankyou_txt":"_332NqVUS8S2VbYunvwwAHQ","poweredby_label":"HVBxyJrQm2gwN8-UEy_Hl","poweredby_logo":"_2bBTB4d8PkO44N1Hozh1Mc","praivacy_message":"_2e9owe5zo6JpzI9sU_9c","thankyou_txt_mobile":"_1tyLLPYqd8Ef_fhXFQEB6a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Thankyou/Thankyou.scss
// module id = 2351
// module chunks = 0